// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect, useRef } from 'react';

// Components
import Button from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';
import FilterButtonDropdown from 'app/shared/modules/MobileSRP/__BaseComponents__/FilterButtonDropdown';
import CommuteFilter from 'app/shared/modules/MobileSRP/Header/FilterModules/CommuteFilter';

// Hooks
import { useCommuteFilterButtonStatus } from './hooks';

const CommuteFilterButton = ({ ariaButtonLabel, ariaDropdownLabel, onButtonClick, onModalClose, showDropdown }) => {
  // All filter buttons should have this ref to return focus after user has closed the filter modal
  const focusRef = useRef(null);
  const isLoaded = useRef(null);

  useEffect(() => {
    /**
     * isLoaded is a component instance variable. Do not set focus on the button until
     * after the component has been interacted with.
     * @see: https://reactjs.org/docs/hooks-faq.html#is-there-something-like-instance-variables
     */
    if (!isLoaded.current) {
      isLoaded.current = true;
    } else {
      if (!showDropdown) {
        focusRef.current.focus();
      }
    }
  }, [showDropdown]);

  const isFilterActive = useCommuteFilterButtonStatus();

  return (
    <>
      <Button
        ariaLabel={ariaButtonLabel}
        ariaExpanded={showDropdown}
        active={isFilterActive}
        onClick={onButtonClick}
        ref={focusRef}
        showCarat
      >
        Commute
      </Button>
      {showDropdown && (
        <FilterButtonDropdown
          ariaLabel={ariaDropdownLabel}
          dropdownId={'commute-filter-dropdown'}
          onClose={onModalClose}
        >
          <CommuteFilter showResetButton />
        </FilterButtonDropdown>
      )}
    </>
  );
};

export default CommuteFilterButton;
